import React, { useEffect } from 'react';
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from "react-router-dom";

import { ProvideAuth, useAuth } from "./use-auth.js";
import { SecureRoute } from "./secure-route.js";

// import { Home } from "./components/home.js"

// import logo from './logo.svg';
import './App.css';

import { BaseWrapper } from './components/base-wrapper.js';
import { SubscribePage } from './components/subscribe.js';
import { RenewPackage } from './components/renew-package.js';

import { Dashboard } from './components/dashboard.js';
import { MonthViewPage } from './components/month-view-page.js'; 
import { WorkOrderApp } from './components/work-order-app.js';
import { WorkReportApp } from './components/work-report-app.js';
import { WorkHistoryApp } from './components/work-history-app.js';

import { PrintWrapper } from './components/print-wrapper.js';

import { OrganizeInfo } from './components/org-info.js';
import { UserManage } from './components/user-manage.js';

function App(props) {
  const auth = useAuth();

  /**
   * See script in welcome.html about opening sigin page
   */
  useEffect(() => {
    return true;
    // eslint-disable-next-line no-unreachable
    if(auth && auth.user) return;

    const uri = 'http://localhost:3005/login';
    const popup = window.open(`${uri}`, 'KpxPlatformWindow', 'width=400,height=500');

    function cb(e) {
      console.info(e);

      if (e.data === 'HELLO') {
        popup.close();
        window.removeEventListener('message', cb);
      }
    }
    // eslint-disable-next-line no-unreachable
    window.addEventListener('message', cb);
  }, [auth]);

  return (
    <ProvideAuth>
      <Router>
        <Switch>
          <Route exact path="/" >
            <Redirect to="/dashboard" />
          </Route>
          {/*
          <Route exact path="/home" >
            <Home />
          </Route>
          */}
          <Route exact path="/subscribe" >
            <SubscribePage />
          </Route>

          <Route exact path="/packages" >
            <RenewPackage />
          </Route>

          <Route path="/print/:page/:id">
            <PrintWrapper>
              <p>Print Form Page</p>
            </PrintWrapper>
          </Route>

          <SecureRoute>
            <BaseWrapper>
              <Switch>
                <Route path="/dashboard">
                  <Dashboard />
                </Route>

                <Route path="/calendar/due">
                  <MonthViewPage />
                </Route>

                <Route path={["/work-order/:work_id", "/work-order"]}>
                  <WorkOrderApp />
                </Route>

                <Route path="/work-report/:page">
                  <WorkReportApp />
                </Route>

                <Route path="/work-history/:page">
                  <WorkHistoryApp />
                </Route>

                <Route path="/org-user">
                  <UserManage />
                </Route>

                <Route path="/org-info">
                  <OrganizeInfo />
                </Route>

              </Switch>
            </BaseWrapper>
          </SecureRoute>

        </Switch>
      </Router>
    </ProvideAuth>
  );
}
    /*
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
      </header>
    </div>
    */

export default App;
